<template>
    <div class="w-100">
        <div class="label-container-mobile">
            <div ref="label" class="label-promo-text" v-html="labelOpt"></div>
            <div v-if="timerShow" class="label-timer">{{hours | numberFormat}}:{{mins | numberFormat}}:{{secs | numberFormat}}</div>
        </div>
    </div>
</template>
<script>
import timer from '@/Utilities/timer';
import homeUtils from '@/Utilities/homeUtils';
export default {
    name: 'BlockLabel',
    props:{
        timeCounter:{
            type: Number,
            default: 0
        },
        label:{
            type: String,
            default: ''
        }
    },
    data(){
        return {
            timerShow: false,
            labelOpt: '',
            hours: 0,
            mins: 0,
            secs: 0
        }
    },
    mounted() {
        this.removeClass();
        this.setVar();
    },
    methods: {
        removeClass(){
            this.labelOpt = homeUtils.removeClass(this.label);
        },
        setVar() {
            let calc = timer.calcTimerCounter(this.timeCounter);
            if(!calc){
                this.timerShow = false;
                return;
            }
            this.secs = calc.secs;
            this.mins = calc.mins;
            this.hours = calc.hours;
            this.timerShow = true;
            setTimeout(() => {this.setVar();}, 1000);
        }
    },
    filters: {
        numberFormat(value){
            return timer.formatNumberCounter(value);
        }
    }
}
</script>